<template>
  <section>
    <div class="proccess-title">
      {{ $t('Gattaran_Feedback__QMDO' /** 处理进度 */) }}
    </div>
    <div v-loading="loading" class="proccess-timeline">
      <pb-timeline style="padding: 0px">
        <pb-timeline-item v-for="(item, index) in getHistory" :key="index" :timestamp="item.content" :icon="item.icon || ''" :type="item.type || ''" :color="item.color || ''" placement="top">
          <div>
            {{ item.timezone }} {{ item.timezone && index !== 1 ? '|' : '' }}
            <a v-if="index !== 1" class="dc-href" :href="`dchat://im/start_conversation?name=${data.chargeUser}`"> {{ data.chargeUser }}</a>
            <img v-if="index !== 1" class="dc-img" :src="require('../assets/DC.svg')" />
          </div>
          <div v-if="index === 0" class="proccess-conclusion">
            {{ getConclusion }}
          </div>
        </pb-timeline-item>
      </pb-timeline>
    </div>
  </section>
</template>

<script>
import { CURRENT_STATUS } from '../config';
import _ from 'lodash';
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getHistory() {
      const { status } = this.data;
      const history = _.get(this.data, 'history', []);
      // 如果处理进度长度不为0
      if (history.length !== 0) {
        // 自定义待处理的节点样式
        if (status === CURRENT_STATUS.PROCCESSING) {
          Object.assign(history[0], {
            color: '#FF8D5C',
          });
          // 自定义处理完成的节点样式
        } else if (status === CURRENT_STATUS.DONE) {
          Object.assign(history[0], {
            type: 'success',
            icon: 'pb-icon-check',
          });
        }
        // 自定义提交反馈的节点样式
        Object.assign(history[1], {
          type: 'success',
          icon: 'pb-icon-check',
        });
      }
      return history;
    },
    getConclusion() {
      const history = _.get(this.data, 'history', []);
      const { status } = this.data;
      const { conclusion } = history[0];
      // 如果状态为已完成且节点是头一个才会有处理结论
      return status === 3 ? conclusion : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.proccess {
  &-title {
    height: 34px;
    box-sizing: border-box;
    margin: 16px;
    padding: 6px 0 6px 16px;
    background: #f8f8fa;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #282b33;
    line-height: 22px;
    font-weight: 600;
  }

  &-timeline {
    margin: 16px 24px;
  }

  &-conclusion {
    margin-top: 6px;
    font-size: 14px;
    color: #595c66;
    line-height: 22px;
  }
}
.dc-img {
  width: 12px;
  height: 13px;
  margin-left: 4px;
}
.dc-href {
  color: #ff7a45;
  text-decoration: none;
}
:deep(.proccess-timeline) {
  // timeline timeStamp样式
  .pb-timeline-item__content {
    margin-bottom: 8px;
    padding-top: 6px;
    font-size: 14px;
    color: #8d9099;
    line-height: 22px;
  }
  // timeline content 样式
  .pb-timeline-item__timestamp.is-top {
    margin-bottom: 0;
    padding-top: 0;
    color: #030405;
    font-size: 14px;
  }
  .pb-timeline-item__wrapper {
    top: 0;
  }
  // 节点样式修改
  .pb-timeline-item__node--normal {
    width: 16px;
    height: 16px;
    left: -3px;
  }
}
</style>
